import { Base } from './Base';

export abstract class EdgeBase extends Base
{
	public setConfiguration(syncId, parentObj)
	{
		this._syncId		= syncId;
		this._parentObj		= parentObj;
		this._isTerm		= false;
		return this;
	}
	public getRequest(type, data=null)
	{
		var msgObj			= this.getMessage(type, data);
		msgObj["data"]		= btoa(JSON.stringify(msgObj["data"]));
		return this.getParent().getParent().newRequest(msgObj);
	}
	public getEvent(reqObj)
	{
		var msgObj			= reqObj.getRxData();
		
		var evObj			= {};
		evObj["type"]		= msgObj.type;
		evObj["txId"]		= msgObj.txId;
		evObj["data"]		= JSON.parse(atob(msgObj.data));
		evObj["subObj"]		= this;
		//include the connection user data, it may be needed for validation etc
		evObj["userData"]	= reqObj.getSrcConn().getUserData();
		return evObj;
	}
}